import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowPopup(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowPopup(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="fixed z-50 bottom-5 left-5 right-5 bg-white shadow-lg p-4 rounded-lg flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0 sm:space-x-4">
      <div className="grid">
        <h2 className="text-small font-bold mb-2">We value your privacy</h2>
        <p className="text-small text-gray-700">
          We use cookies to improve your shopping experience. By clicking
          "Accept", you consent to our use of cookies. For more information,
          please review our
          <Link
            to="/settings/privacyPolicy"
            className="text-coffeeBrown underline ml-1"
          >
            Privacy Policy
          </Link>
          .
        </p>
      </div>
      <div className="flex space-x-2">
        <button
          onClick={handleAccept}
          className="bg-coffeeBrown text-white px-4 py-2 rounded hover:bg-coffee"
        >
          Accept
        </button>
        <button
          onClick={handleDecline}
          className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
        >
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
